import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import { buy_InvoiceApi } from "../../app/slices/buy_InvoiceSlice";
import DateSearchComponent from "../../components/customTable/DateSearchComponent";
import { Box, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { toast } from "react-toastify";
import { ContentCopy, Delete } from "@mui/icons-material"; // Import the copy icon from MUI

// import { toast } from "react-toastify";

export default function BuyInvoice() {
  const dispatch = useDispatch();

  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  });
  useEffect(() => {
    dispatch(buy_InvoiceApi(queryParams));
  }, [dispatch, queryParams]);
  const handleSearch = (startDate, endDate) => {
    setQueryParams({ startDate, endDate });
  };

  const sliceResponse = useSelector(
    (state) => state.buy_Invoice.buy_Invoice.data
  );
  const stateLoading = useSelector(
    (state) => state.buy_Invoice.loading
  );



  const columnHelper = createMRTColumnHelper();

  const columns = [
    columnHelper.accessor("customerRefNo", {
      header: "Customer Ref. No.",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.customerRefNo);
          toast.success("copied to clipboard!");
        };

        return (
          <Tooltip title={cell.row.original?.customerRefNo}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.userInfoName}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("invoiceNumber", {
      header: "Invoice Number",
      size: 150,
      Cell: (cell) => cell.row.original?.invoiceNumber,
    }),
    columnHelper.accessor("invoiceDate", {
      header: "Invoice Date",
      size: 200,
      Cell: (cell) => cell.row.original?.invoiceDate?.split(" ")[0],
    }),
    columnHelper.accessor("grossAmount", {
      header: "Gross Amount",
      size: 150,
      Cell: (cell) => cell.row.original?.grossAmount,
    }),
    columnHelper.accessor("netAmount", {
      header: "Net Amount",
      size: 150,
      Cell: (cell) => cell.row.original?.netAmount,
    }),
    columnHelper.accessor("totalTaxAmount", {
      header: "Total Tax",
      size: 150,
      Cell: (cell) => cell.row.original?.totalTaxAmount,
    }),
    columnHelper.accessor("taxAmount", {
      header: "Tax Amount",
      size: 150,
      Cell: (cell) => cell.row.original?.taxAmount,
    }),
    columnHelper.accessor("taxPerc", {
      header: "Tax Percentage",
      size: 150,
      Cell: (cell) => cell.row.original?.taxPerc,
    }),
    columnHelper.accessor("taxesType", {
      header: "Taxes Type",
      size: 150,
      Cell: (cell) => cell.row.original?.taxesType,
    }),
    columnHelper.accessor("metalType", {
      header: "Metal Type",
      size: 150,
      Cell: (cell) => cell.row.original?.metalType,
    }),
    columnHelper.accessor("karat", {
      header: "Karat",
      size: 150,
      Cell: (cell) => cell.row.original?.karat,
    }),
    columnHelper.accessor("purity", {
      header: "Purity",
      size: 150,
      Cell: (cell) => cell.row.original?.purity,
    }),
    columnHelper.accessor("quantity", {
      header: "Quantity (g)",
      size: 150,
      Cell: (cell) => cell.row.original?.quantity,
    }),
    columnHelper.accessor("rate", {
      header: "Rate",
      size: 150,
      Cell: (cell) => cell.row.original?.rate,
    }),
    columnHelper.accessor("tcsAmount", {
      header: "TCS Amount",
      size: 150,
      Cell: (cell) => cell.row.original?.tcsAmount,
    }),
    columnHelper.accessor("tcsPerc", {
      header: "TCS Percentage",
      size: 150,
      Cell: (cell) => cell.row.original?.tcsPerc,
    }),
    columnHelper.accessor("discountAmount", {
      header: "Discount Amount",
      size: 150,
      Cell: (cell) => cell.row.original?.discountAmount,
    }),
    columnHelper.accessor("discountType", {
      header: "Discount Type",
      size: 150,
      Cell: (cell) => cell.row.original?.discountType,
    }),
    columnHelper.accessor("discountValue", {
      header: "Discount Value",
      size: 150,
      Cell: (cell) => cell.row.original?.discountValue,
    }),
    columnHelper.accessor("description", {
      header: "Description",
      size: 200,
      Cell: (cell) => cell.row.original?.description,
    }),
    columnHelper.accessor("userInfoName", {
      header: "Customer Name",
      size: 200,
      Cell: (cell) => cell.row.original?.userInfoName,
    }),
    columnHelper.accessor("userInfoState", {
      header: "State",
      size: 150,
      Cell: (cell) => cell.row.original?.userInfoState,
    }),
    columnHelper.accessor("userInfoPincode", {
      header: "Pincode",
      size: 150,
      Cell: (cell) => cell.row.original?.userInfoPincode,
    }),
    columnHelper.accessor("userInfoAddress", {
      header: "Address",
      size: 200,
      Cell: (cell) => cell.row.original?.userInfoAddress || "N/A",
    }),
    columnHelper.accessor("userInfoCity", {
      header: "City",
      size: 150,
      Cell: (cell) => cell.row.original?.userInfoCity || "N/A",
    }),
    columnHelper.accessor("userInfoEmail", {
      header: "Email",
      size: 200,
      Cell: (cell) => cell.row.original?.userInfoEmail || "N/A",
    }),
    columnHelper.accessor("userInfoMobileNumber", {
      header: "Mobile Number",
      size: 150,
      Cell: (cell) => cell.row.original?.userInfoMobileNumber || "N/A",
    }),
  ];

  return (
    <>
      {/* */}
      <>
        <DateSearchComponent onSearch={handleSearch} />
        <Box mt={2} >
          <CustomTable columns={columns} data={sliceResponse} loading={stateLoading} permissionKey="BuyInvoice"/>
        </Box>
      </>

    </>
  );
}
